export default __webpack_public_path__ + "static/media/ISMO CLASS-6 EXAM PATTERN 2025.2bc83ca9.pdf";